export function arrayMove(list: any[], from: number, to: number): any[] {
	const listCopy = [...list];

	from = from < 0 ? listCopy.length + from : from;
	to = to < 0 ? listCopy.length + to : to;

	if (from >= listCopy.length || from < 0) {
		throw new Error('from index is out of bounds');
	}
	if (to < 0) {
		throw new Error('to index is out of bounds');
	}

	if (to >= listCopy.length) {
		let k = to - listCopy.length + 1;
		while (k--) {
			listCopy.push(undefined);
		}
	}
	listCopy.splice(to, 0, listCopy.splice(from, 1)[0]);

	return listCopy;
}
